var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error"},[_c('mpx-image',{staticClass:"error-img",attrs:{"src":"https://pt-starimg.didistatic.com/static/starimg/img/e3fgOAxwky1653462896827.png"}}),_vm._l(((_vm.errorMsg)),function(item,index){return _c('span',{staticClass:"error-text"},[_vm._v(_vm._s(item))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }